import "./SignIn.scss";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import { client } from "../../utils/network";
import useUser from "../../data/useUser";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { StylesProvider } from "@material-ui/core/styles";

import { Button, Checkbox, Typography } from "../../ui";

import { ReactComponent as LogoWhiteIcon } from "../../assets/images/logo-white.svg";
import LogoWhiteIconRetargeo from "../../assets/images/retargeo-logo-white.jpg";
import * as Yup from "yup";
import FormWithText from "../../widgets/FormWithText/FormWithText";
import { useDispatch } from "react-redux";
import { setUserData } from "../../redux/user/actions";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import EmailModal from "../../widgets/EmailModal/EmailModal";
import { getDomainConfig } from "../../configs/main";
import { useDispatch as useReduxDispatch } from "react-redux";
import { setSupportOrigin } from "../../redux/pageContext/actions";

const saveDataInLocalStorage = (isSave) => {
  return localStorage.setItem(
    "programmatic_save_password",
    isSave ? "true" : "false"
  );
};

const setButtonsDisabled = (disabled) => {
  for (let button of document.getElementsByClassName('Button')) {
    button.disabled = disabled;
  }
}

function SignIn() {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success');
  const err = searchParams.get('err');
  const email = searchParams.get('email');
  const [open, setOpen] = useState(false)
  const navigate = useNavigate();
  const { mutate: userMutate } = useUser();
  const dispatch = useDispatch();
  const rDispatch = useReduxDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [showPassword, setShowPassword] = useState(false);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const supportEmail = "techsupport@retargeo.ru";
  const encodedSupportEmail = encodeURIComponent(supportEmail);
  const emailClients = [
    {
      label: "mail.ru",
      url: `https://e.mail.ru/compose/?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/mail.ru",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=mail.ru&sz=64",
    },
    {
      label: "Яндекс Почта",
      url: `https://mail.yandex.ru/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/yandex.ru",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=yandex.ru&sz=64",
    },
    {
      label: "Gmail",
      url: `https://mail.google.com/mail/?view=cm&fs=1&to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/gmail.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=gmail.com&sz=64",
    },
    {
      label: "Microsoft Outlook",
      url: `https://outlook.office.com/mail/deeplink/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/outlook.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=outlook.com&sz=64",
    },
    {
      label: "iCloud Mail",
      url: `https://www.icloud.com/mail/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/icloud.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=icloud.com&sz=64",
    },
  ];

  const handleSupportClick = () => {
    rDispatch(setSupportOrigin("auth_signin_button"));
    setIsSupportModalOpen(true);
  };

  const handleClientSelect = (url) => {
    window.open(url, "_blank");
    setIsSupportModalOpen(false);
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const {
    values,
    handleChange,
    setFieldValue,
    handleSubmit,
    errors,
    touched,
    setErrors,
    handleBlur,
  } = useFormik({
    validationSchema: Yup.object().shape({
      username: Yup.string().trim()
        .matches(/^([\w.-]+)@([\w-]+\.)+([\w]{2,})$/i, "Введите корректный Email")
        .required("Пожалуйста, введите ваш Email"),
      password: Yup.string().required("Это обязательное поле"),
    }),
    initialValues: {
      username: "",
      password: "",
      isSavePassword: true,
    },
    onSubmit: async (values) => {
      setButtonsDisabled(true);
      try {
        const params = new URLSearchParams();
        params.append("username", values.username.trim());
        params.append("password", values.password);
        const { data } = await client.post("/api/v1/auth/access-token", params);
        saveDataInLocalStorage(values.isSavePassword);
        localStorage.setItem("token", data.access_token);
        const user = await userMutate();
        dispatch(setUserData(user));
        navigate("/");
      } catch (error) {
        if (error.message === '{"detail":"Некорректный никнейм или пароль"}') {
          enqueueSnackbar("Неверный Email или пароль", { variant: "error", 
            anchorOrigin:{ vertical: "top", horizontal: "right" }
          });
        } else if (error.message === '{"detail":"Необходимо подтвердить почту"}') {
          enqueueSnackbar("Необходимо подтвердить почту для входа", { variant: "error", 
            anchorOrigin:{ vertical: "top", horizontal: "right" }
          });
        } else {
          enqueueSnackbar(error.message, { variant: "error", 
            anchorOrigin:{ vertical: "top", horizontal: "right" }
          });
        }
      }
      setButtonsDisabled(false);
    },
  });
  const handleInput = (e) => {
    handleChange(e);
    setErrors({});
  };
  const handleChangeCheckbox = () => {
    setFieldValue("isSavePassword", !values.isSavePassword);
    setErrors({});
  };

  useEffect(()=>{
    if(success) {
      enqueueSnackbar("Регистрация успешно подтверждена", { variant: "success", 
        anchorOrigin:{ vertical: "top", horizontal: "right" }
      });
    }
  },[])
  useEffect(()=>{
    if(err) setOpen(true)
  },[])

  return (
    <div className="SignIn">
      <div className="images">
        <Link to="/">
          {getDomainConfig().brand === 'retargeo' ? <img width={350} src={LogoWhiteIconRetargeo} className="logo" alt="" /> : <LogoWhiteIcon className="logo" />}
        </Link>

        <div className="greetings">
          <Typography className="greetings-title" variant="h1" color="white">
            Приветствуем Вас!
          </Typography>
          <Typography variant="h1" color="white">
            {getDomainConfig().brand === 'retargeo' ? 'Программный RTB комплекс retargeo.ru - это полностью российская разработка для управления цифровой рекламой и данными.' : 'Программный RTB комплекс Programmatic.ru - это полностью российская разработка для управления цифровой рекламой и данными.'}
          </Typography>
        </div>
      </div>
      <form className="wrapp" onSubmit={handleSubmit}>
        <div className="form">
          <Typography className="form-title" variant="h1" color="dark-gray">
            Войти
          </Typography>
          <FormWithText>
            <div className="validate_input">
              <input
                id="username"
                name="username"
                className={errors.username && touched.username ? "email-field err" : "email-field"}
                type="text"
                placeholder="Email"
                value={values.username.trim() || ""}
                onChange={handleInput}
                autoComplete="off"
                onBlur={handleBlur}
              />
              {touched.username && errors.username ? (
                  <div className="error_text">{errors.username}</div>
                ) : null}
            </div>
            <StylesProvider injectFirst>
            <div className="validate_input">
              <Input
                  disableUnderline={true}
                  id="password"
                  name="password"
                  className={errors.password && touched.password ? "password-field err" : "password-field"}
                  autoComplete="off"
                  type={showPassword ? "text" : "password"}
                  placeholder="Пароль"
                  value={values.password}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              {touched.password && errors.password ? (
                  <div className="error_text">{errors.password}</div>
                ) : null}
              </div>
            </StylesProvider>
            <div className="save-password">
              <div
                className="remember unselectable"
                onClick={handleChangeCheckbox}
              >
                <Checkbox
                  onChange={handleChangeCheckbox}
                  value={values.isSavePassword}
                />
                <Typography variant="body1" color="dark-gray">
                  запомнить пароль
                </Typography>
              </div>
              <Link to="/password-recovery">
                <div className="forgot">Забыли пароль?</div>
              </Link>
            </div>
          </FormWithText>

          <div className="btn-actions">
            <Button type="submit" variant="primary" className="primary">
              Войти
            </Button>
            <Link to="/sign-up">
              <Button variant="secondary">Зарегистрироваться</Button>
            </Link>
            {
              (getDomainConfig().brand === "retargeo" || getDomainConfig().title === "Programmatic Beta") && (
                <Button
                  type="button"
                  variant="secondary"
                  style={{ marginTop: 10 }}
                  onClick={handleSupportClick}
                >
                  Связаться с поддержкой
                </Button>
              )
            }
            {isSupportModalOpen && (
              <div
                style={{
                  position: "fixed",
                  inset: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.45)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                }}
                onClick={() => setIsSupportModalOpen(false)}
              >
                <div
                  style={{
                    width: "100%",
                    maxWidth: 420,
                    backgroundColor: "#fff",
                    borderRadius: 10,
                    padding: 20,
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div style={{ fontSize: 18, fontWeight: 600 }}>Выберите почтовый клиент</div>
                  {emailClients.map((client) => (
                    <button
                      key={client.label}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        border: "1px solid #d9d9d9",
                        borderRadius: 8,
                        backgroundColor: "#fff",
                        cursor: "pointer",
                        textAlign: "left",
                        fontSize: 14,
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                      }}
                      onClick={() => handleClientSelect(client.url)}
                    >
                      <img
                        src={client.iconUrl}
                        alt={client.label}
                        onError={(e) => {
                          if (e.currentTarget.src !== client.fallbackIconUrl) {
                            e.currentTarget.src = client.fallbackIconUrl;
                          }
                        }}
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          objectFit: "cover",
                          flexShrink: 0,
                          border: "1px solid #e5e5e5",
                        }}
                      />
                      {client.label}
                    </button>
                  ))}
                  <button
                    style={{
                      marginTop: 4,
                      width: "100%",
                      padding: "10px 12px",
                      border: "none",
                      borderRadius: 8,
                      backgroundColor: "#f2f2f2",
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                    onClick={() => setIsSupportModalOpen(false)}
                  >
                    Отмена
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
      <EmailModal open={open} handleClose={()=> setOpen(false)} err={err} email={email} />
    </div>
  );
}

export default SignIn;
